import {changeEvent, clickEvent, customEvent, documentLoadEvent} from "../../../webpack/modules/events";
import {
    addToCart,
    addToCartExtra,
    closeAiTool,
    closeImageExamples,
    hideCancelConfirmation,
    hideError,
    initExamplesInfo,
    initImageExamples,
    initProductsInfo,
    removeSelectedUploadedImages,
    selectUploadedImage,
    setCurrentStepDone,
    showCancelConfirmation,
    switchStep,
    toggleImageExamples,
    unselectAllUploadedImages,
    unselectUploadedImage,
    uploadImages
} from "../../../webpack/modules/ai-avatar";
import {openCart} from "../../../webpack/modules/cart";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

documentLoadEvent(function() {
    initImageExamples();
    initProductsInfo();
    initExamplesInfo();
});

customEvent('hide.bs.offcanvas', '#ai-tool', false, function(element, event) {
    if (element.dataset.closing != 'true') {
        event.preventDefault();
        if (element.dataset.status == 'open') {
            showCancelConfirmation();
        }
    } else {
        element.dataset.status = 'in-progress';
    }
});

customEvent('hidden.bs.offcanvas', '#ai-tool', false, function(element) {
    element.dataset.closing = 'false';
    let step = element.dataset.step;
    let backdrop = document.querySelector('.offcanvas-backdrop.show');
    if (backdrop) {
        backdrop.remove();
        document.querySelector('body').style.overflow = null;
        document.querySelector('body').style.paddingRight = null;
    }
    element.dataset.status = 'closed';
    hideCancelConfirmation();
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) {
        chatWidget.style.display = 'block';
    }
    element.dataset.step = '1';
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: 'close',
        content_type: step == 100 ? 'last' : step
    });
});

customEvent('show.bs.offcanvas', '#ai-tool', false, function(element) {
    element.dataset.status = 'in-progress';
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) {
        chatWidget.style.display = 'none';
    }
});

customEvent('shown.bs.offcanvas', '#ai-tool', false, function(element) {
    element.dataset.status = 'open';
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: 'start'
    });
});

clickEvent('#ai-tool-continue', false, hideCancelConfirmation);

clickEvent('.ai-tool-close', false, function(element) {
    hideCancelConfirmation();
    closeAiTool();
    if (element.classList.contains('close-from-confirmation')) {
        ga4TrackSimpleEvent({
            event: 'avatar_tool',
            method: 'close_from_confirmation'
        });
    }
});

clickEvent('.model', false, function(element) {
    if (!element.classList.contains('selected')) {
        document.querySelectorAll('.model.selected').forEach((model) => model.classList.remove('selected'));
        element.classList.add('selected');
    }

    document.querySelector('#avatar-model').value = element.dataset.model;
    setCurrentStepDone();
});

clickEvent('#ai-tool-next', false, function(element) {
    switchStep(parseInt(element.dataset.current) + 1);
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: 'next_step',
        content_type: parseInt(element.dataset.current) + 1
    });
});

clickEvent('.ai-tool-prev', false, function(element) {
    switchStep(parseInt(element.dataset.current) - 1);
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: 'prev_step',
        content_type: parseInt(element.dataset.current) - 1
    });
});

clickEvent('#show-image-examples', false, toggleImageExamples);

clickEvent('#ai-tool', false, function(element, event) {
    let stepImages = document.querySelector('.step-images');
    let examples = document.querySelector('#image-examples');

    if (stepImages.classList.contains('active') && !examples.contains(event.target)) closeImageExamples();
});

changeEvent('.upload-ai-image', false, function(element, event) {
    let eventMethod = 'upload_from_gallery';
    let files = event.target.files;
    if (!files.length) return;
    uploadImages(files);
    element.value = '';
    if (element.getAttribute('capture')) {
        eventMethod = 'upload_from_selfie';
        document.querySelectorAll('.uploaded-img .upload-btn input').forEach((input) => input.setAttribute('capture', 'user'));
    } else {
        eventMethod = 'upload_from_gallery';
        document.querySelectorAll('.uploaded-img .upload-btn input').forEach((input) => input.removeAttribute('capture'));
    }
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: eventMethod
    });
});

clickEvent('.upload-btn.main', false, function(element) {
    if (!element.classList.contains('active')) {
        let actives = document.querySelectorAll('.upload-btn.active');
        if (actives) {
            actives.forEach(function(item) {
                item.classList.remove('active');
            });
        }
        element.classList.add('active');
    }
});

customEvent('load', '.uploaded-img img', false, function(element) {
    element.closest('.uploaded-img').classList.remove('loading');
});

clickEvent('.uploaded-img:not(.empty)', true, function(element) {
    if (!element.classList.contains('selected')) {
        selectUploadedImage(element);
    } else {
        unselectUploadedImage(element);
    }
});

clickEvent('#uploaded-images-discard', false, removeSelectedUploadedImages);

clickEvent('#uploaded-images-cancel', false, unselectAllUploadedImages);

changeEvent('input[name="physical-product"]', false, function(input) {
    if (input.checked) {
        document.querySelectorAll('input[name="physical-product"]:checked').forEach(function(checkedInput){
            if (checkedInput.id != input.id) checkedInput.checked = false;
        });
    }
});

clickEvent('#ai-tool-add-to-cart', false, addToCart);

clickEvent('#ai-tool-go-cart', false, function() {
    closeAiTool();
    ga4TrackSimpleEvent({
        event: 'avatar_tool',
        method: 'confirm'
    });
    setTimeout(openCart, 500);
});

clickEvent('.physical-product', false, function(element) {
    addToCartExtra(element);
});

clickEvent('#error-close', false, function() {
    hideError();
});